module.exports = __webpack_public_path__ + "static/img/f-step2.3efd4b9f.png";